<div class="container-full" style="margin-top:15px;">
    <div class="ace-heading-banner">
        <div style="padding-top:18px;">
            <span class="ace-heading-text-level-1" style="margin-left:25px;color:white;">PARCS Lot Setup</span>
         </div>
    </div>
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
    <div style="margin-left:30px;margin-right:30px;">
    <ng-container *ngIf="isParcsInAddMode">
        <!-- <p style="font-size:18px;font-weight: bold;">This Lot is associated with a PARCS</p> -->
        <p style="font-size:18px;font-weight: bold;">Please click the "Activate PARCS" button to inititiate integration.</p>


        <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;" *ngIf="!activationInProgress" (click)="onActivateParcs()">Activate PARCS</button>
        <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;" *ngIf="activationInProgress" (click)="onCancelActivateParcs()">Cancel Activate PARCS</button>
        @if(activationInProgress){
            <div class="row" style="margin-top:30px;">
                <div class="col-12">
                <form [formGroup]="parcsSelectionForm">
                    <mat-form-field style="width: 50%;min-width:300px;" >
                        <mat-label>Select PARCS</mat-label>
                        <mat-select formControlName="parcName" required (selectionChange)="onSelectParcsName()">
                        @for (parc of parcsList; track parc) {
                            <mat-option [value]="parc.parcsId">{{parc.parcsDisplayName}}</mat-option>
                        }
                        </mat-select>
                    </mat-form-field>
                    <div>
                    </div>
                </form>
                </div>
            </div>
            
            @if(selectedParcsName.toUpperCase() === 'AMANO ONE'){
                <p style="font-size:18px;font-weight: bold;">Activating PARCS: {{lotParcsConfiguration.parcsDisplayName}}</p>
                <app-amano-one [parcsId]="selectedParcsId" [parcsName]="selectedParcsName"></app-amano-one>
            }
            @else if(selectedParcsName.toUpperCase() === 'FLASH'){
                <p style="font-size:18px;font-weight: bold;">Activating PARCS: {{lotParcsConfiguration.parcsDisplayName}}</p>
                <app-flash-setup-home [parcsId]="selectedParcsId" [parcsName]="selectedParcsName"></app-flash-setup-home>
            }
        }   
    </ng-container>
    <ng-container *ngIf="!isParcsInAddMode">
        <strong>{{selectedParcsName.toUpperCase()}} PARCS is activated for Lot {{lotParcsConfiguration.lotNumber}}.</strong>
        @if(selectedParcsName.toUpperCase() === 'AMANO ONE'){
            @if(deactivationInProgress){
                <div style="margin-top:5px;margin-bottom:30px;width:100%;">
                    <app-processing-banner [WaitMessage]="'Deactivating PARCS...'" style="width:100%"></app-processing-banner>
                </div>
            }

            @if(isLprEnabled){
                <div class="row">
                    <div class="col-6">
                        <p style="font-size:18px;">This Lot is PARCS Activated with <strong>{{selectedParcsName}}</strong></p>
                    </div>
                    <div class="col-6">
                        <p style="font-size:18px;">LPR Enabled: <strong>Yes</strong></p>
                    </div>
                </div>
            }
            @else {
                <div class="row">
                    <div class="col-4">
                        <p style="font-size:18px;">This Lot is PARCS Activated with <strong>{{selectedParcsName}}</strong></p>
                    </div>
                    <div class="col-4">
                        <p style="font-size:18px;">LPR Enabled: <strong>No</strong></p>
                    </div>
                    @if(facilityId !== '') {
                        <div class="col-4">
                            <p style="font-size:18px;">Facility Id: <strong>{{facilityId}}</strong></p>
                        </div>
                    }
                </div>
            }
            @if(isLprUpdatingAccessHoldersInProgress){
                <div style="margin-top:5px;margin-bottom:30px;width:100%;">
                    <app-processing-banner [WaitMessage]="'Updating LPR Access Holders...'" style="width:100%"></app-processing-banner>
                </div>
            }
            <mat-tab-group style="margin-top:10px;">
                <mat-tab label="Update Settings "> 
                    <div class="container-fluid">
                        <div class="row" style="margin-top:30px;">
                            <div class="col-6">
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" [(ngModel)]="lprEnableStatus" (change)="onLprStatusChanged()">
                                    <mat-button-toggle value="lprDisabled">LPR Disabled</mat-button-toggle>
                                    <mat-button-toggle value="lprEnabled">LPR Enabled</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Credential Values">
                    <div class="container-fluid">
                        <div class="row" style="margin-top:30px;">
                            <p style="font-size:18px;font-weight: bold;">Maintain Credential Types and Codes</p>
                            <app-amano-one-credential-settings></app-amano-one-credential-settings>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Deactivate PARCS">
                    <div class="container-fluid">
                        <div class="row" style="margin-top:30px;">
                            <p style="font-size:18px;font-weight: bold;">Click the Deactivate PARCS button if you wish to remove from this Lot.</p>
                            <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;width:200px;" *ngIf="!activationInProgress" (click)="onDeactivateParcs()">Deactivate PARCS</button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Multiple Facility Setup">
                    <div class="container-fluid">
                        <div class="row" style="margin-top:30px;align-items:center;gap:12px;">
                            <p style="font-size:18px;font-weight: bold; margin-bottom:0;">Enable Multple Facility to Lot Feature.</p>
                            <mat-slide-toggle
                                [checked]="multipleFacilityMappingEnabled"
                                (change)="onMultipleFacilityMappingToggleChanged($event)">
                            </mat-slide-toggle>
                            <span style="font-size:16px; font-weight:600;">
                                {{ multipleFacilityMappingEnabled ? 'Deactivate' : 'Activate' }}
                            </span>
                            <ng-container *ngIf="multipleFacilityMappingEnabled">
                                <app-amano-one-admin-multiple-facility-mapping></app-amano-one-admin-multiple-facility-mapping>
                            </ng-container>
                        </div>
                    </div>
                </mat-tab>
                
        </mat-tab-group>
        }
        @else if(selectedParcsName.toUpperCase() === 'FLASH'){
            <app-flash-activated-home></app-flash-activated-home>
        }
    </ng-container>
    </div> 
        </mat-card-content>
</mat-card>
</div>


  